<ng-container *transloco="let t">
  @if(isLoading){
    <ng-container>
      <app-loader [isLoading]="isLoading"></app-loader>
    </ng-container>
  }
  <section>
    @if (favoriteItems.length > 0) {
      <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
        @for(item of favoriteItems; track item){
          <div class="col mb-4">
            <app-event-grid-item-with-image [countries]="countries" [isLanding]="true"
                                            (click)="goToEventDetailsPage(item)" [isOnWishList]="true"
                                            [languages]="languages"
                                            [isFinishedEvent]="this.calendarType === EventItemType.MY_FINISHED"
                                            [eventItem]="item"/>
          </div>
        }
      </div>
    } @else {
      <app-empty-state/>
    }
  </section>
</ng-container>
